import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  minNiche: {
    defaultValue: 'Pelo menos um nicho deve estar selecionado',
    key: 'industry-category-niche-tab-minNiche',
  },
  compareThemes: {
    defaultValue: 'Comparar temas',
    key: 'industry-category-niche-tab-compareThemes',
  },
  nicheMinLimitMessage: (nicheMinLimit: number) => ({
    key: 'Niche-nicheMinLimitMessage',
    parameters: {
      nicheMinLimit,
    },
    defaultValue: 'Selecione ao menos {nicheMinLimit} nichos para gerar o report.',
  }),
})
